import React, { useState } from 'react';
import SelectionPerformer from '../SelectionPerformer';

function ApplicantsIndex() {
  return (
    <>
      <div className="w-full flex flex-1 mt-10 p-1">
        <div className="container relative flex flex-1 flex-col lg:flex-row  mx-auto max-w-[1163px]">
          <SelectionPerformer
            isApplicants
            onClose={() => {
              // setOpenSelected(false);
            }}
          />
        </div>
      </div>
    </>
  );
}

export default ApplicantsIndex;
